import api from '@/helpers/api';

export default {
  // obsolete ?
  fetchTeamList({ commit }, merchantId) {
    commit('START_LOADING_TEAMS');
    api('GET', `/merchants/${merchantId}/teams`)
      .then((response) => {
        if (response.status === 200) {
          commit('SET_TEAMS_LIST', response.data);
        }
      })
      .catch((error) => {
        commit('API_ERROR', error.response);
      });
  },
  createTeam({ commit }, payload) {
    commit('TEAM_SAVED', false);
    api('POST', `/merchants/${payload.merchant_id}/teams`, payload.data)
      .then((response) => {
        if (response.status === 200) {
          commit('TEAM_SAVED', true);
        }
      })
      .catch((error) => {
        commit('API_ERROR', error.response);
      });
  },
  updateTeam({ commit }, payload) {
    commit('TEAM_SAVED', false);
    api('PUT', `/merchants/${payload.merchant_id}/teams/${payload.team_id}`, payload.data)
      .then((response) => {
        if (response.status === 200) {
          commit('TEAM_SAVED', true);
        }
      })
      .catch((error) => {
        commit('API_ERROR', error.response);
      });
  },
  deleteTeam({ commit }, payload) {
    commit('TEAM_DELETED', false);
    api('DELETE', `/merchants/${payload.merchant_id}/teams/${payload.team_id}`)
      .then((response) => {
        if (response.status === 200) {
          commit('TEAM_DELETED', payload.team_id);
        }
      })
      .catch((error) => {
        commit('API_ERROR', error.response);
      });
  },
};
